<template>
    <div>
        <div class="modal fade" id="mdconsultartituloscobranca">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Selecionar títulos para cobrança...</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbemitidos">Emitidos:</label>
                                <select class="form-control form-control-sm" id="cbemitidos" v-model="vemitidos">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <span class="lblselect2">Cliente:</span>
                                <select id="cbclientect" data-placeholder="Selecione um cliente" data-allow-clear="true"
                                        style="width:100%;" v-model="vidclientect">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbSituacao">Situação:</label>
                                <select class="form-control form-control-sm" id="cbSituacao" v-model="vsituacao">
                                    <option value="0">Ativo</option>
                                    <option value="1">Inativo</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbfiltroperiodoct">Período:</label>
                                <select class="form-control form-control-sm" id="cbfiltroperiodoct" v-model="vfiltroperiodoct" v-bind="selecionaperiodoct">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <label for="cbfiltroporct">Por:</label>
                                <select class="form-control form-control-sm" id="cbfiltroporct" v-model="vfiltroporct" v-bind:disabled="hab_desab_periodoct">
                                    <option value="0">Dt. Vencimento</option>
                                    <option value="1">Dt. Emissão</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtinict">De:</label>
								<div class="input-group">
									<date-picker id="eddtinict" v-model="vdtinipesqct" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodoct"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfimct">até:</label>
								<div class="input-group">
									<date-picker id="eddtfimct" v-model="vdtfimpesqct" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodoct"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>							
                            <div class="col-sm-12 col-md-2 col-lg-2 col-md-offset-2 col-lg-offset-2">
                            <label for="cbqtdregct">Registros:</label>
                                <select class="form-control form-control-sm" id="cbqtdregct" v-model="itemsPorPaginact">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3 dvajuste">
                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()" style="margin-top: 20px;"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflsttitulos"
                                        :rows="lsttitulos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="slot_cliente" slot-scope="item">
                                        <span>{{ mtdformatarzeros(item.row.idcliente, 6) }} - {{ item.row.nomecliente }}</span>
                                    </template>
                                    <template slot="slot_valor" slot-scope="item">
                                        <span style="color: #6c757d; font-weight: 700;">{{ mtdformatavalordecimal(parseFloat(item.row.vlresta), 2) }}</span>
                                    </template>                                                                                                             
                                </vue-bootstrap4-table>
                            </div>                            
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <v-pagination
                                            v-model="vpagina_atual"
                                            :page-count="vqtd_paginas"
                                            :classes="bootstrapPaginationClasses">
                                    </v-pagination>
                                </div>
                                <div class="col-sm-12 col-md-4 col-lg-4" style="padding-top: 8px;">
                                    <a href="#" role="button" class="btn btn-success btn-sm" @click.prevent="mtdenviarselecionados()" data-toggle="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-check"></i> Confirmar seleção</a>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 8px;">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 2px;"><i class="fa fa-close"></i> Cancelar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>    
</template>
<script>
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'
    export default {
        name: 'cmpconsultartituloscobranca',
            components:{
                VueBootstrap4Table,
                vPagination
            },    
        props:[
            'idconta'
        ],
        data: function() {
            return {
                lsttitulos          : [],
                vfiltroperiodoct    : 1,
                vfiltroporct        : 0,
                vdtinipesqct        : util.DataAtual(true),
                vdtfimpesqct        : util.DataAtual(true),
                itemsPorPaginact    : '99999999999',
                vqtd_paginas        : 1,
                vpagina_atual       : 1,  
                vqtd_total_registros: 0,              
                hab_desab_periodoct : false,
                vidclientect        : null,
                vemitidos           : 2,
                vsituacao           : 0,
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                columns: [
                    {
                        label: "Nr. Título",
                        name: "codtit",
                        sort: true
                    },
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemitit",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vencimento",
                        name: "dtventit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Valor",
                        name: "vlresta",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        slot_name: "slot_valor",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Observações",
                        name: "obstit",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }                                
            };
        },
        methods: {
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},            
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtdiniciar_def(){
                let vself = this;
                $('#mdconsultartituloscobranca').on('shown.bs.modal', function (e) {
                    vself.mtdlimpar_listagem();
                    $('#cbemitidos').focus();
                });
				$('#mdconsultartituloscobranca').on('hidden.bs.modal', function (e) {
					vself.mtdfecharconsulta();
				});	                
                $("#cbclientect").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbclientes',
                                c1: 'id',
                                c2: 'nome'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 2,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidclientect = $("#cbclientect").val();
                    vself.mtdlimpar_listagem();
                });
            },                        
            mtdfiltropesquisa(){
                let rfiltro = ' and t.idconta=' + this.idconta;
                // if(this.pidfilial !== null) {                    
                //     rfiltro = rfiltro + 'and t.idfilial=' + this.pidfilial;
                // }                 
                if(this.vidclientect !== null) {
                    rfiltro = ' and t.idcliente=' + this.vidclientect;
                }
				if(parseInt(this.vfiltroperiodoct) === 1){
                    let strpor = parseInt(this.vfiltroporct) === 0 ? 'dtventit' : 'dtemitit';
					rfiltro = rfiltro + ' and t.'+strpor+' between "' + util.InverterData(this.vdtinipesqct) + '" and "' + util.InverterData(this.vdtfimpesqct) + '"';
                }
                if(parseInt(this.vsituacao) < 2){
                    rfiltro = rfiltro + ' and t.inativo='+this.vsituacao;
                }
                switch (parseInt(this.vemitidos)){
                    case 0: rfiltro = rfiltro + ' and t.idbancoboleto = 0 ';
                        break;
                    case 1: rfiltro = rfiltro + ' and t.idbancoboleto > 0';
                        break;
                }
                rfiltro = rfiltro + ' and t.sttit in ("A", "P")';                            
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'situacao',     valor  : 0},//pesquisar somente os em aberto
                    {parametro: 'ordem',        valor  : 2},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    vself.vqtd_total_registros = parseInt(response.data.itemsPorPaginact);
                    let qtdpg                  = Math.ceil(vself.vqtd_total_registros / vself.itemsPorPaginact);
                    vself.vqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregatitulos(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },            
            mtdcarregatitulos(ipagina){
                var vself       = this;                    
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                vself.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table 
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'situacao',     valor  : 0},//pesquisar somente os em aberto
                    {parametro: 'ordem',        valor  : 2}, 
                    {parametro: 'dtbasecalculo',valor  : util.InverterData(util.DataAtual(true))},                                                
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.itemsPorPaginact},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.itemsPorPaginact)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceberv2.php');
                retorno.then(function (response) {
                    vself.lsttitulos = response.data.lista;
                    loader.hide();
                }).catch(function (response) {
                    vself.lsttitulos = [];
                    loader.hide();
                });
            },
            mtdlimpar_listagem() {
                this.lsttitulos             = [];
                this.$refs.reflsttitulos.selected_items = [];//limpa os ítens selecionados na table
                this.vpagina_atual          = 1;
                this.vqtd_total_registros   = 0;
                this.vqtd_paginas           = 0;
            },
            mtdenviarselecionados(){
                if (this.$refs.reflsttitulos.selected_items.length === 0){
                    this.$toastr.w('Selecione ao menos um título!', 'Atenção!');
                    return;
                }
				let payload = {
					lsttituloscobret    : this.$refs.reflsttitulos.selected_items			
				};
				this.$store.commit('TITCOB_RETORNO_CHANGE',payload);					
				this.mtdfecharconsulta();                
            },
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_TITCOB_CHANGE',payload);								
			},            
        },
        mounted: function() {
            this.mtdiniciar_def();
        },    
        computed:{
            abrirtela(){
                return this.$store.state.consultatituloscob.abrirtela;                
            },	             
            selecionaperiodoct: function () {
                if(parseInt(this.vfiltroperiodoct) === 0){
                    this.hab_desab_periodoct = true;
                }else{
                    this.hab_desab_periodoct = false;
                }
            }        
        },
        watch: {
			abrirtela(val){
				if (val){
					$('#mdconsultartituloscobranca').modal('show');
				}else{					
					$('#mdconsultartituloscobranca').modal('hide');
				}
			},            
            vpagina_atual(val){
                this.mtdcarregatitulos(val);
            },
        }
    }
</script>
<style>
    #mdconsultartituloscobranca{
        z-index: 1090!important;
    }
</style>